import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box
} from '@mui/material';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import getApiBase from './getApiBase';

const ApprovalPendingModal = ({ open, onClose, persistent = false }) => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await fetch(`${getApiBase()}/api/auth/logout`, {
        method: "POST",
        credentials: "include",
      });
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      navigate("/login");
    } catch (err) {
      console.error("❌ Logout failed:", err);
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      navigate("/login");
    }
  };
  return (
    <Dialog 
      open={open} 
      onClose={persistent ? undefined : onClose} // Disable close when persistent
      maxWidth="sm"
      fullWidth
      disableEscapeKeyDown={persistent} // Prevent ESC key from closing
      hideBackdrop={false}
      PaperProps={{
        sx: {
          // Make it more prominent when persistent
          ...(persistent && {
            boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
            border: '3px solid #e63926'
          })
        }
      }}
    >
      <DialogTitle sx={{ textAlign: 'center', pt: 3 }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
          <HourglassEmptyIcon sx={{ fontSize: 60, color: '#e63926' }} />
        </Box>
        <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#e63926' }}>
          Awaiting Network Approval
        </Typography>
      </DialogTitle>
      
      <DialogContent>
        <Typography variant="body1" sx={{ textAlign: 'center', fontSize: '1.1rem', mb: 2 }}>
          Your shop registration is currently under review by our admin team.
        </Typography>
        <Typography variant="body1" sx={{ textAlign: 'center', fontSize: '1.1rem', mb: 2 }}>
          Your shop will be activated once approved by an administrator, typically within <strong>24 hours</strong>.
        </Typography>
        <Typography variant="body2" sx={{ textAlign: 'center', color: '#666', mb: 2 }}>
          Thank you for your patience!
        </Typography>
        {persistent && (
          <Typography variant="body2" sx={{ textAlign: 'center', color: '#e63926', fontWeight: 'bold', mt: 2 }}>
            This message will remain visible until your shop is approved.
          </Typography>
        )}
      </DialogContent>
      
      <DialogActions sx={{ justifyContent: 'center', pb: 3, gap: 2 }}>
        {persistent ? (
          // When persistent, show logout button
          <Button 
            onClick={handleLogout}
            variant="contained"
            sx={{
              backgroundColor: '#4285f4',
              color: '#fff',
              '&:hover': { backgroundColor: '#1b449e' },
              px: 4
            }}
          >
            Logout
          </Button>
        ) : (
          // When not persistent, show OK button
          <Button 
            onClick={onClose}
            variant="contained"
            sx={{
              backgroundColor: '#4285f4',
              color: '#fff',
              '&:hover': { backgroundColor: '#1b449e' },
              px: 4
            }}
          >
            OK
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ApprovalPendingModal;

